import { CartUpdateEvent } from '@theme/events';

export function purchaseAfterScroll(current, buttonBottom, viewportTop = 0) {
  if (!Number.isFinite(buttonBottom) || !Number.isFinite(viewportTop)) return false;
  return current ? buttonBottom <= viewportTop + 8 : buttonBottom < viewportTop - 16;
}

const dock = document.getElementById('bayrak-mobile-dock');
if (dock) {
  const messages = JSON.parse(dock.querySelector('[data-dock-i18n]')?.textContent || '{}');
  const i18n = key => messages[key] || key;
  const group = dock.querySelector('.bayrak-dock__group');
  const toolbar = dock.querySelector('.bayrak-dock__toolbar');
  const search = dock.querySelector('.bayrak-dock__search');
  const panels = [...dock.querySelectorAll('[data-dock-panel]')];
  const live = dock.querySelector('[data-dock-live]');
  const product = JSON.parse(dock.querySelector('[data-dock-product]')?.textContent || 'null');
  const surface = document.createElement('span');
  surface.className = 'bayrak-dock__surface';
  surface.setAttribute('aria-hidden', 'true');
  group.prepend(surface);
  const motionPreference = matchMedia('(prefers-reduced-motion: reduce)');
  const actionButtons = [...toolbar.querySelectorAll('[data-dock-action]')];
  const purchaseButtons = [...dock.querySelectorAll('[data-dock-add]')];
  const productNames = [...dock.querySelectorAll('[data-dock-product-name]')];
  const productPrices = [...dock.querySelectorAll('[data-dock-product-price]')];
  const productImages = [...dock.querySelectorAll('.bayrak-dock-product__image')];
  const stockLabel = dock.querySelector('[data-dock-stock]');
  const variantLabel = dock.querySelector('[data-dock-variant-name]');
  const purchaseSummary = dock.querySelector('.bayrak-dock-product');
  let mode = 'rest', purchase = false, compact = false, queued = false, busy = false;
  let productForm = null, addButton = null, variantLoading = false, pending = false, unconfirmed = false;
  let nativeSticky = null, quantityInput = null, header = null, collisionControls = [], previewFrames = [];
  let targetsDirty = true, productDirty = true, environmentDirty = true, geometryDirty = true, panelSizeDirty = true;
  let previewOffset = 0, maxScroll = 0, collisionRects = [], groupBounds = null, searchBounds = null;
  let nativeDialogOpen = false, keyboardHidden = false, renderedState = '', renderedPanel = null;
  let surfaceAnimation, searchAnimation, panelAnimation;
  let noticeTimer, addTimer, cartTimer, cartRequest = null, cart = null, removing = false, cartRevision = 0, cartUpdatedAt = 0;
  let nativeVersion = 0, lastScroll = scrollY, scrollDistance = 0, lastDirection = 0, lastAction = 'categories';
  const observedPreviewElements = new WeakSet();
  const previewObserver = new ResizeObserver(queueEnvironment);
  const formObserver = new MutationObserver(queueProduct);
  const nativeObserver = new MutationObserver(queueProduct);
  const geometryObserver = new ResizeObserver(queueGeometry);
  const panelObserver = new ResizeObserver(queuePanelSize);
  panels.forEach(panel => panelObserver.observe(panel));
  geometryObserver.observe(document.body);

  function setData(key, value) {
    const next = String(value);
    if (dock.dataset[key] !== next) dock.dataset[key] = next;
  }
  function attribute(node, name, value) { const next = String(value); if (node.getAttribute(name) !== next) node.setAttribute(name, next); }
  function text(node, value) { if (node.textContent !== value) node.textContent = value; }
  function inert(node, value) { if (node.inert !== value) node.inert = value; }
  function renderedMode() { return mode === 'rest' && purchase ? 'purchase' : mode; }
  function animateSurface(previous, next) {
    surfaceAnimation?.cancel();
    if (!motionPreference.matches && innerWidth <= 749 && previous?.width && next.width &&
        (Math.abs(previous.width - next.width) > .5 || Math.abs(previous.height - next.height) > .5)) {
      surfaceAnimation = surface.animate([
        { transform: `scale(${previous.width / next.width},${previous.height / next.height})` },
        { transform: 'none' }
      ], { duration: 220, easing: 'cubic-bezier(.2,.7,.2,1)' });
    }
  }
  function render() {
    const current = renderedMode();
    const previous = groupBounds && surface.getBoundingClientRect();
    const previousSearch = searchBounds && search.getBoundingClientRect();
    setData('mode', current);
    setData('compact', current === 'rest' && compact);
    for (const panel of panels) { const hidden = panel.dataset.dockPanel !== current; if (panel.hidden !== hidden) panel.hidden = hidden; inert(panel, hidden); }
    inert(toolbar, ['notice'].includes(current));
    inert(search, current !== 'rest');
    for (const button of actionButtons) {
      if (button.hasAttribute('aria-haspopup')) attribute(button, 'aria-expanded', button.dataset.dockAction === current);
      attribute(button, 'data-current', current === 'rest' && button.dataset.dockAction === 'categories');
    }
    for (const button of purchaseButtons) {
      const disabled = Boolean(!unconfirmed && (busy || variantLoading || !addButton || addButton.disabled || addButton.getAttribute('aria-busy') === 'true'));
      if (button.disabled !== disabled) button.disabled = disabled;
      attribute(button, 'aria-busy', busy || variantLoading);
      const quantity = Number(quantityInput?.value || productForm?.dataset.quantityDefault || 1);
      text(button, unconfirmed ? i18n('view_cart') : busy ? i18n('adding') : variantLoading ? i18n('updating') : !product?.available ? (product?.variantId ? i18n('sold_out') : i18n('unavailable')) : addButton?.disabled ? i18n('unavailable') : `${i18n('add_to_cart')}${quantity > 1 ? ` (${quantity})` : ''}`);
    }
    const panel = panels.find(p => !p.hidden);
    const height = current === 'rest' ? (compact ? 48 : 60) : current === 'notice' ? 82 : current === 'purchase' ? Math.max(132, panel.offsetHeight + 82) : panel.offsetHeight + 82;
    const nextHeight = `${Math.ceil(height)}px`;
    if (group.style.height !== nextHeight) group.style.height = nextHeight;
    groupBounds = group.getBoundingClientRect();
    searchAnimation?.cancel();
    searchBounds = search.getBoundingClientRect();
    animateSurface(previous, groupBounds);
    if (!motionPreference.matches && current === 'rest' && previousSearch?.width && searchBounds.width && Math.abs(previousSearch.width - searchBounds.width) > .5) {
      searchAnimation = search.animate([
        { transform: `scale(${previousSearch.width / searchBounds.width})` }, { transform: 'none' }
      ], { duration: 180, easing: 'cubic-bezier(.2,.7,.2,1)' });
    }
    if (panel !== renderedPanel) {
      panelAnimation?.cancel();
      if (panel && !motionPreference.matches) panelAnimation = panel.animate([
        { opacity: 0, transform: 'translateY(5px)' }, { opacity: 1, transform: 'none' }
      ], { duration: 160, delay: current === 'purchase' ? 0 : 50, fill: 'backwards', easing: 'ease-out' });
    }
    renderedPanel = panel;
    renderedState = `${current}:${current === 'rest' && compact}`;
    panelSizeDirty = false;
  }
  function setMode(next, focus = false) {
    clearTimeout(noticeTimer); mode = next; compact = false; render(); queueLayout();
    if (focus && next !== 'rest') requestAnimationFrame(() => panels.find(p => !p.hidden)?.querySelector('button,a')?.focus({ preventScroll: true }));
  }
  function error(message) {
    for (const node of dock.querySelectorAll('[data-dock-error]')) { node.textContent = message; node.hidden = !message; }
    if (message) live.textContent = message;
    render(); queueLayout();
  }
  function syncProduct() {
    if (!product) return;
    const nextForm = [...document.querySelectorAll('main product-form-component')].find(f => f.dataset.productId === String(product.id));
    if (nextForm !== productForm) {
      productForm = nextForm || null;
      formObserver.disconnect();
      if (productForm) formObserver.observe(productForm, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'value'], characterData: true });
    }
    addButton = productForm?.querySelector('button[name="add"]') || null;
    quantityInput = productForm?.querySelector('[name="quantity"]') || null;
    const nextSticky = document.querySelector(`sticky-add-to-cart[data-product-id="${product.id}"]`);
    if (nextSticky !== nativeSticky) {
      nativeSticky = nextSticky;
      nativeObserver.disconnect();
      if (nativeSticky) nativeObserver.observe(nativeSticky, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-current-variant-id', 'data-variant-available', 'src', 'srcset'] });
    }
    if (nativeSticky && !variantLoading) {
      product.variantId = nativeSticky.dataset.currentVariantId || '';
      product.available = nativeSticky.dataset.variantAvailable === 'true';
      const price = nativeSticky.querySelector('.price__sale:not(.price__hidden) .price,.price__regular:not(.price__hidden) .price')?.textContent?.trim();
      const name = nativeSticky.querySelector('.sticky-add-to-cart__title')?.textContent?.trim();
      const variant = nativeSticky.querySelector('.sticky-add-to-cart__variant')?.textContent?.trim() || '';
      if (name) product.title = name;
      for (const node of productNames) text(node, product.title);
      for (const node of productPrices) if (price) text(node, price);
      if (variantLabel) text(variantLabel, variant);
      const image = nativeSticky.querySelector('[ref="productImage"]');
      for (const target of productImages) {
        if (image && target.src !== image.src) { target.src = image.src; target.removeAttribute('srcset'); target.alt = image.alt; }
      }
    }
    if (stockLabel) text(stockLabel, variantLoading ? i18n('updating_selection') : product.available ? i18n('in_stock') : i18n('currently_unavailable'));
    if (purchaseSummary) attribute(purchaseSummary, 'aria-label', `${product.title}, ${productPrices[0].textContent}, ${i18n('view_selection')}`);
  }
  function refreshTargets() {
    targetsDirty = false;
    header = document.querySelector('header');
    previewFrames = [...document.querySelectorAll('#PBarNextFrameWrapper,iframe[id*="preview"],#shopify-preview-bar,#ShopifyPreviewBar')];
    for (const frame of previewFrames) if (!observedPreviewElements.has(frame)) {
      observedPreviewElements.add(frame); previewObserver.observe(frame);
    }
    collisionControls = [...document.querySelectorAll('main product-form-component button[name="add"],main a.button,main shopify-accelerated-checkout')];
    if (header) geometryObserver.observe(header);
    productDirty = environmentDirty = geometryDirty = true;
  }
  function syncLayout() {
    queued = false;
    if (targetsDirty) refreshTargets();
    const productChanged = productDirty;
    if (productDirty) { productDirty = false; syncProduct(); geometryDirty = true; }
    const environmentChanged = environmentDirty;
    if (environmentDirty) {
      environmentDirty = false;
      previewOffset = 0;
      for (const frame of previewFrames) {
        const r = frame.getBoundingClientRect();
        if (r.height > 0 && r.height < 180 && Math.abs(r.bottom - innerHeight) < 5) previewOffset = Math.max(previewOffset, r.height);
      }
      const consent = document.getElementById('shopify-pc__banner');
      const consentBounds = consent?.getBoundingClientRect();
      const consentOpen = Boolean(consentBounds?.height && getComputedStyle(consent).visibility !== 'hidden');
      nativeDialogOpen = consentOpen || Boolean(document.querySelector('dialog[open],header-drawer details[open]'));
      const editing = document.activeElement?.matches('input:not([type="button"]):not([type="checkbox"]):not([type="radio"]),textarea,[contenteditable="true"]');
      keyboardHidden = Boolean(editing && !document.activeElement.closest('dialog') && window.visualViewport && innerHeight - visualViewport.height > 160);
    }
    const original = addButton?.getBoundingClientRect();
    if (geometryDirty) {
      geometryDirty = false;
      maxScroll = Math.max(0, document.scrollingElement.scrollHeight - document.scrollingElement.clientHeight);
      collisionRects = collisionControls.filter(control => control !== addButton && control.isConnected).map(control => {
        const r = control.getBoundingClientRect();
        return { top: r.top + scrollY, bottom: r.bottom + scrollY, left: r.left, right: r.right, width: r.width, height: r.height };
      });
    }
    if (product && productForm && original?.width && original?.height) {
      purchase = purchaseAfterScroll(purchase, original.bottom, window.visualViewport?.offsetTop || 0);
    } else purchase = false;
    const productTopHidden = Boolean(product && !purchase);
    setData('productTopHidden', productTopHidden);
    if (productTopHidden && mode !== 'rest') setMode('rest');
    const previewValue = `${previewOffset}px`;
    if (document.body.style.getPropertyValue('--bayrak-preview-offset') !== previewValue) document.body.style.setProperty('--bayrak-preview-offset', previewValue);
    const current = renderedMode();
    if (productChanged || environmentChanged || panelSizeDirty || renderedState !== `${current}:${current === 'rest' && compact}`) render();
    const regions = current === 'rest' ? [groupBounds, searchBounds] : [groupBounds];
    const controls = collisionRects.map(r => ({ ...r, top: r.top - scrollY, bottom: r.bottom - scrollY }));
    if (original) controls.push(original);
    const overlaps = ['rest', 'purchase'].includes(current) && controls.some(r =>
      r.width > 0 && r.height > 0 && regions.some(d => d && r.top < d.bottom && r.bottom > d.top && r.left < d.right && r.right > d.left));
    setData('modalHidden', nativeDialogOpen);
    setData('keyboardHidden', keyboardHidden);
    setData('purchaseHidden', overlaps);
    inert(dock, innerWidth > 749 || productTopHidden || nativeDialogOpen || keyboardHidden || overlaps);
  }
  function queueLayout() { if (!queued) { queued = true; requestAnimationFrame(syncLayout); } }
  function queueProduct() { productDirty = true; queueLayout(); }
  function queueEnvironment() { environmentDirty = geometryDirty = true; queueLayout(); }
  function queueGeometry() { geometryDirty = true; queueLayout(); }
  function queuePanelSize() { panelSizeDirty = true; queueLayout(); }
  function queueTargets() { targetsDirty = true; queueLayout(); }
  function money(amount) { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: cart?.currency || 'USD' }).format(amount / 100); }
  function renderCount(count) {
    if (!Number.isInteger(count) || count < 0) return;
    const badge = dock.querySelector('[data-dock-count]'); badge.textContent = String(count); badge.hidden = count === 0;
    toolbar.querySelector('[data-dock-action="cart"]').setAttribute('aria-label', count ? `${i18n('cart')}, ${count} ${i18n('items')}` : i18n('cart'));
  }
  function renderCart() {
    if (!cart) return;
    renderCount(cart.item_count);
    const container = dock.querySelector('[data-dock-cart-items]');
    const fragment = document.createDocumentFragment();
    for (const item of cart.items) {
      const row = document.createElement('div'); row.className = 'bayrak-dock-cart-item';
      if (item.image) { const image = document.createElement('img'); image.src = item.image; image.alt = ''; image.width = 44; image.height = 58; row.append(image); }
      const copy = document.createElement('div'); copy.className = 'bayrak-dock-cart-item__copy';
      const link = document.createElement('a'); link.href = item.url; link.textContent = item.product_title; copy.append(link);
      const detail = document.createElement('small'); detail.textContent = `${item.variant_title && item.variant_title !== 'Default Title' ? `${item.variant_title} · ` : ''}${item.quantity} × ${money(item.final_price)}`; copy.append(detail);
      row.append(copy);
      const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'bayrak-dock__close'; remove.dataset.dockRemove = item.key; remove.setAttribute('aria-label', `${i18n('remove')} ${item.product_title}`); remove.textContent = '×'; remove.disabled = removing; row.append(remove); fragment.append(row);
    }
    container.replaceChildren(fragment);
    const message = dock.querySelector('[data-dock-cart-message]'); message.textContent = cart.item_count ? '' : i18n('empty_cart'); message.hidden = cart.item_count > 0;
    dock.querySelector('[data-dock-cart-total]').hidden = cart.item_count === 0;
    dock.querySelector('[data-dock-cart-subtotal]').textContent = money(cart.total_price);
    const checkout = dock.querySelector('[data-dock-checkout]'); checkout.hidden = cart.item_count === 0; checkout.inert = removing; checkout.setAttribute('aria-disabled', String(removing));
    render(); queueLayout();
  }
  async function refreshCart() {
    if (cartRequest) return cartRequest;
    const revision = cartRevision;
    cartRequest = (async () => {
      const response = await fetch(`${dock.dataset.cartUrl}.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: AbortSignal.timeout(8000) });
      if (!response.ok) throw Error(i18n('load_error'));
      const result = await response.json();
      if (revision === cartRevision) { cart = result; cartUpdatedAt = Date.now(); renderCart(); }
      return cart;
    })();
    try { return await cartRequest; } finally { cartRequest = null; }
  }
  async function openCart() {
    setMode('cart', true);
    if (cart && Date.now() - cartUpdatedAt < 5000) { renderCart(); return; }
    const message = dock.querySelector('[data-dock-cart-message]');
    try { await refreshCart(); } catch (e) { message.textContent = e.message; message.hidden = false; render(); }
  }
  async function openNative(kind) {
    const version = ++nativeVersion;
    const target = kind === 'cart' ? document.querySelector('cart-drawer-component') : document.getElementById('search-modal');
    const method = kind === 'cart' ? 'open' : 'showDialog';
    if (typeof target?.[method] !== 'function') return false;
    setMode('rest');
    for (const other of [document.querySelector('cart-drawer-component'), document.getElementById('search-modal')]) {
      if (other !== target && other?.querySelector('dialog')?.open && typeof other.closeDialog === 'function') await other.closeDialog();
    }
    await new Promise(resolve => requestAnimationFrame(resolve));
    if (version === nativeVersion && !target.querySelector('dialog')?.open) {
      if (kind === 'cart' && innerWidth <= 749) {
        const restoration = history.scrollRestoration;
        history.scrollRestoration = 'manual';
        target.addEventListener('dialog:close', () => {
          const restore = () => { history.scrollRestoration = restoration; queueEnvironment(); };
          const timer = setTimeout(() => { window.removeEventListener('popstate', afterBack); restore(); }, 500);
          const afterBack = () => requestAnimationFrame(() => { clearTimeout(timer); restore(); });
          window.addEventListener('popstate', afterBack, { once: true });
        }, { once: true });
      }
      target[method]();
    }
    queueLayout(); return true;
  }
  async function removeItem(key) {
    if (removing) return;
    removing = true; let failure = ''; renderCart();
    try {
      const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(c => c.dataset.sectionId))];
      const response = await fetch(`${dock.dataset.cartUrl}/change.js`, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: 0, sections, sections_url: location.pathname }) });
      const result = await response.json();
      if (!response.ok || result.status) throw Error(result.description || i18n('update_error'));
      cart = result; document.dispatchEvent(new CartUpdateEvent(cart, 'bayrak-mobile-dock', { source: 'bayrak-dock', sections: cart.sections }));
    } catch (e) { failure = e.message; }
    finally { removing = false; if (cart) renderCart(); if (failure) { const message = dock.querySelector('[data-dock-cart-message]'); message.textContent = failure; message.hidden = false; render(); } }
  }
  function finishAdd(message = '') {
    clearTimeout(addTimer); pending = false; busy = false; error(message); queueLayout();
  }
  function addProduct() {
    if (unconfirmed) { void openCart(); return; }
    if (busy || variantLoading || !addButton || addButton.disabled || addButton.getAttribute('aria-busy') === 'true') return;
    const form = productForm.querySelector('form');
    if (!form?.reportValidity()) { productForm.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
    const validation = productForm.refs?.quantitySelector?.canAddToCart?.();
    if (validation && !validation.canAdd) { error(i18n('quantity_limit')); return; }
    if (typeof productForm.handleSubmit !== 'function') { productForm.scrollIntoView({ behavior: 'smooth', block: 'center' }); addButton.focus({ preventScroll: true }); return; }
    pending = true; busy = true; error(''); render();
    form.requestSubmit(addButton);
    addTimer = setTimeout(() => { if (pending) { unconfirmed = true; finishAdd(i18n('check_cart')); } }, 15000);
  }
  dock.addEventListener('click', event => {
    const target = event.target.closest('a,button'); if (!target) return;
    if (target.hasAttribute('data-dock-add')) { event.preventDefault(); addProduct(); return; }
    if (target.hasAttribute('data-dock-remove')) { void removeItem(target.dataset.dockRemove); return; }
    if (target.hasAttribute('data-dock-close')) {
      setMode('rest'); requestAnimationFrame(() => (purchase ? dock.querySelector('[data-dock-add]') : toolbar.querySelector(`[data-dock-action="${lastAction}"]`))?.focus({ preventScroll: true })); return;
    }
    if (target.hasAttribute('data-dock-options')) { setMode('rest'); productForm?.closest('.shopify-section')?.querySelector('variant-picker')?.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
    const action = target.dataset.dockAction;
    if (action === 'categories') { nativeVersion++; lastAction = action; setMode(mode === action ? 'rest' : action, mode !== action); }
    if (action === 'product') { lastAction = 'categories'; setMode('product', true); }
    if (action === 'cart') { event.preventDefault(); lastAction = action; if (mode === 'cart') setMode('rest'); else void openCart(); }
    if (action === 'search' || action === 'native-cart') {
      const kind = action === 'native-cart' ? 'cart' : 'search';
      const controller = kind === 'cart' ? document.querySelector('cart-drawer-component') : document.getElementById('search-modal');
      if (typeof controller?.[kind === 'cart' ? 'open' : 'showDialog'] === 'function') { event.preventDefault(); void openNative(kind); }
    }
  });
  document.addEventListener('cart:update', event => {
    const resource = event.detail?.resource;
    cartRevision++;
    if (resource?.items) { cart = resource; cartUpdatedAt = Date.now(); renderCart(); }
    else {
      if (Number.isInteger(resource?.item_count)) renderCount(resource.item_count);
      clearTimeout(cartTimer);
      cartTimer = setTimeout(async () => { try { if (cartRequest) await cartRequest; await refreshCart(); } catch {} }, 120);
    }
    if (pending && event.target === productForm) {
      if (event.detail?.data?.didError) finishAdd(i18n('cart_changed'));
      else { unconfirmed = false; finishAdd(); setMode('notice'); live.textContent = i18n('added_to_cart'); noticeTimer = setTimeout(() => { if (mode === 'notice' && !dock.querySelector('[data-dock-panel="notice"]').contains(document.activeElement)) setMode('rest'); }, 2400); }
    }
    queueLayout();
  });
  document.addEventListener('cart:error', event => { if (pending && event.target === productForm) finishAdd(String(event.detail?.data?.description || event.detail?.data?.message || i18n('add_error'))); });
  document.addEventListener('variant:selected', event => { if (product && event.target.closest('.shopify-section')?.contains(productForm)) { variantLoading = true; error(''); queueProduct(); } });
  document.addEventListener('variant:update', event => {
    if (!product || (String(event.detail?.data?.productId) !== String(product.id) && !event.detail?.data?.newProduct)) return;
    if (event.detail.data.newProduct) product.id = event.detail.data.newProduct.id;
    variantLoading = false; unconfirmed = false; error(''); queueTargets();
  });
  document.addEventListener('quantity-selector:update', queueProduct);
  document.addEventListener('pointerdown', event => { if (mode !== 'rest' && !dock.contains(event.target)) setMode('rest'); }, { passive: true });
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && mode !== 'rest') { setMode('rest'); (purchase ? dock.querySelector('[data-dock-add]') : toolbar.querySelector(`[data-dock-action="${lastAction}"]`))?.focus({ preventScroll: true }); } });
  for (const name of ['dialog:open', 'dialog:close', 'toggle', 'focusin', 'focusout']) document.addEventListener(name, queueEnvironment, true);
  window.addEventListener('scroll', () => {
    const position = Math.max(0, Math.min(scrollY, maxScroll));
    const delta = position - lastScroll; lastScroll = position;
    const direction = Math.sign(delta);
    if (Math.abs(delta) >= 1) {
      if (direction !== lastDirection) scrollDistance = 0;
      lastDirection = direction; scrollDistance += Math.abs(delta);
    }
    if (position < 60) compact = false;
    else if (scrollDistance >= 44) { compact = direction > 0; scrollDistance = 0; }
    queueLayout();
  }, { passive: true });
  window.addEventListener('resize', queueEnvironment, { passive: true });
  window.visualViewport?.addEventListener('resize', queueEnvironment, { passive: true });
  motionPreference.addEventListener('change', () => {
    if (motionPreference.matches) { surfaceAnimation?.cancel(); searchAnimation?.cancel(); panelAnimation?.cancel(); }
  });
  const targetSelector = 'product-form-component,sticky-add-to-cart,header,dialog,#shopify-pc__banner,a.button,shopify-accelerated-checkout,#PBarNextFrameWrapper,iframe[id*="preview"],#shopify-preview-bar,#ShopifyPreviewBar';
  new MutationObserver(records => {
    if (records.some(record => !dock.contains(record.target) && [...record.addedNodes, ...record.removedNodes].some(node =>
      node.nodeType === Node.ELEMENT_NODE && (node.matches(targetSelector) || node.querySelector(targetSelector))))) queueTargets();
  }).observe(document.body, { childList: true, subtree: true });
  document.body.dataset.bayrakDockReady = 'true';
  syncLayout();
}
